<div *ngIf="title">
  <span class="title-tooltip title tooltip_title">{{ title }}</span>
</div>
<div class="title-tooltip definition tooltip_text">
  <span *ngIf="definition && !hidePrefix"
    >Defined as {{ decapitalize(definition) }}</span
  >
  <span *ngIf="definition && hidePrefix">{{ definition }}</span>
</div>
